<template>
  <div class="component-search-button">
    <div style="position:relative">
      <a-input
        placeholder="请输入内容"
        size="large"
        style="width:500px;"
        :value="searchValue"
        @change="e => $emit('onChange', e.target.value)"
      />
      <a-button
        type="primary"
        size="large"
        @click="$emit('onSearch')"
      >
        搜索
      </a-button>
      <ul
        v-show="isOpen"
        class="select-wrapper"
      >
        <a-spin
          v-if="infoLoading"
          style="margin:6px;"
        />
        <li
          v-for="(item,index) in selectData"
          :key="index"
          class="select-item"
          @click="$emit('handleSelect', item)"
        >
          {{ `${item.qichacha_name}` }}
        </li>
      </ul>
    </div>
    <a-icon
      type="search"
      style="position:absolute;top:15px;left:14px;coloe:#565C66;z-index:2;"
    />
  </div>
</template>
<script>
export default {
  props: ['isOpen', 'selectData', 'infoLoading', 'searchValue'],
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
.component-search-button {
  margin-bottom: 20px;
  /deep/ .ant-input {
    padding-left: 30px;
    z-index: 0;
    border-radius: 20px;
  }
  /deep/.ant-btn-primary {
    border-radius: 20px;
    left: -40px;
  }
  .select-wrapper {
    width: 480px;
    max-height: 250px;
    min-height: 30px;
    z-index: 100;
    position: absolute;
    padding: 0;
    background: #fff;
    border-radius: 4px;
    overflow: auto;
    margin-top: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
    transition: all 0.3s;
    .select-item {
      list-style: none;
      padding: 7px 10px;
      margin: 0;
      cursor: pointer;
      &:hover {
        background: #e6f7ff;
      }
    }
  }
}
</style>
